module.exports = __webpack_public_path__ + "static/media/1.395680b7.JPG";